import { Link } from '@/components/atoms/Link';
import { ResponsiveMargin } from '@/components/atoms/legacy/ResponsiveMargin/ResponsiveMargin';
import Logo from '@/components/molecules/Logo';
import React, { Fragment } from 'react';
import { MakeIconMono } from '../../atoms/MakeIconMono';

export interface DealerMakeIconsProps {
  makes: string[];
}

const DealerMakeIcons: React.FC<DealerMakeIconsProps> = ({ makes }) => {
  return (
    <div className="flex gap-[20px]">
      {makes.map((make) => {
        return (
          <Fragment key={make}>
            <MakeIconMono
              make={make}
              className="size-[40px] text-neutral-100 ml:hidden"
            />
            <MakeIconMono
              make={make}
              className="hidden size-[48px] text-neutral-100 ml:block"
            />
          </Fragment>
        );
      })}
    </div>
  );
};

export interface DealerHeaderProps {
  makes: string[];
  dealerName: string;
}

const MobileDealerHeader: React.FC<DealerHeaderProps> = ({
  makes,
  dealerName,
}) => {
  return (
    <div className="bg-gradient-to-r from-darkBrand-start to-darkBrand-end">
      <div className="flex justify-center bg-white bg-opacity-10 px-xl py-l">
        <div>
          <Link href="/">
            <Logo width={99} reverse />
          </Link>
        </div>
      </div>
      <div className="flex flex-col items-center gap-l p-xl">
        <h1 className="text-center text-h3SemiBold text-neutral-100">
          {dealerName}
        </h1>
        <DealerMakeIcons makes={makes} />
      </div>
    </div>
  );
};

const DesktopDealerHeader: React.FC<DealerHeaderProps> = ({
  makes,
  dealerName,
}) => {
  return (
    <div className="bg-gradient-to-r from-darkBrand-start to-darkBrand-end">
      <div className="bg-white bg-opacity-10 py-xl">
        <ResponsiveMargin>
          <div className="flex gap-[20px]">
            <div className="pb-[15px] pt-[9px]">
              <Link href="/">
                <Logo width={119} reverse />
              </Link>
            </div>
            <div className="flex flex-grow items-center justify-center gap-l text-h4SemiBold text-neutral-100 l:text-h3SemiBold">
              <div className="flex items-center gap-[20px]">
                <div>{dealerName}</div>
                <DealerMakeIcons makes={makes} />
              </div>
            </div>
          </div>
        </ResponsiveMargin>
      </div>
    </div>
  );
};

export const DealerHeader: React.FC<DealerHeaderProps> = (props) => {
  return (
    <>
      <div className="ml:hidden">
        <MobileDealerHeader {...props} />
      </div>
      <div className="hidden ml:block">
        <DesktopDealerHeader {...props} />
      </div>
    </>
  );
};
